class Header {
	classes = {
		headerScrolledClass: 'header-scrolled',
		headerAbsoluteClass: 'header-absolute',
		heroArrowBlendClass: 'hero__arrow--blend',
		navListOpenClass: 'nav__list--open',
		xIcon: 'ph-x',
		listIcon: 'ph-list',
	};

	constructor(header) {
		this.header = header;
		this.isDynamic = header.dataset.dynamic === 'true';
		this.heroArrow = header.querySelector('#heroArrow');
		this.mobileBtn = document.querySelector('#mobileBtn');
		this.mobileBtnIcon = document.querySelector('#mobileBtnIcon');
		this.navList = document.querySelector('#navList');
		this._init();
	}

	_init() {
		this.mobileBtn?.addEventListener('click', this._handleMobileBtn);
		if (this.isDynamic) window.onscroll = this._handleScroll;
		else this.header.classList.add(this.classes.headerScrolledClass);
	}

	_handleScroll = () => {
		const { headerAbsoluteClass, headerScrolledClass, heroArrowBlendClass } =
			this.classes;
		if (window.scrollY > 0) {
			this.header.classList.add(headerScrolledClass);
			this.header.classList.remove(headerAbsoluteClass);
			this.heroArrow?.classList.add(heroArrowBlendClass);
		} else {
			this.header.classList.remove(headerScrolledClass);
			this.header.classList.add(headerAbsoluteClass);
			this.heroArrow?.classList.remove(heroArrowBlendClass);
		}
	};

	_handleMobileBtn = e => {
		const { navListOpenClass, xIcon, listIcon } = this.classes;
		this.navList?.classList.toggle(navListOpenClass);
		const isMobileNavOpen = this.navList?.classList.contains(navListOpenClass);
		console.log(e.target);
		console.log(isMobileNavOpen);
		if (isMobileNavOpen) {
			const windowWith = window.innerWidth;
			const htmlWidth = document.documentElement.clientWidth;
			const scrollbarWidth = windowWith - htmlWidth;
			document.documentElement.style.overflow = 'hidden';
			document.body.style.paddingRight = `${scrollbarWidth}px`;
			this.mobileBtn.style.marginRight = `${scrollbarWidth}px`;
			this.mobileBtnIcon?.classList.replace(listIcon, xIcon);
		} else {
			this.mobileBtnIcon?.classList.replace(xIcon, listIcon);
			document.documentElement.style.overflow = 'auto';
			document.body.style.paddingRight = '0px';
			this.mobileBtn.style.marginRight = '0px';
		}
	};
}

export default Header;
